// extracted by mini-css-extract-plugin
export var animationContainer = "_o2-0";
export var footer = "_o2-1";
export var gray = "_o2-2";
export var lineItem = "_o2-3";
export var lineItemImage = "_o2-4";
export var lineItemInfo = "_o2-5";
export var lineItemText = "_o2-6";
export var lineItems = "_o2-7";
export var modalContent = "_o2-8";
export var options = "_o2-9";
export var orderName = "_o2-a";
export var refundAmount = "_o2-b";